//Web Component to load a different video file on mobile than desktop
class MobileSpecificVideo extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.boundResize = this.sourceSelector.bind(this);
  }

  connectedCallback() {
    if (!this.video) return;

    this.setupListeners();
    this.sourceSelector();
  }

  disconnectedCallback() {
    this.teardownListeners();
  }

  setupListeners() {
    window.addEventListener('resize', this.debounce(this.boundResize, 100));
    document.addEventListener('shopify:section:load', this.boundResize);
  }

  teardownListeners() {
    window.removeEventListener('resize', this.debounce(this.boundResize, 100));
    document.removeEventListener('shopify:section:load', this.boundResize);
  }

  sourceSelector() {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;
    const breakpoint = parseInt(this.getAttribute('data-breakpoint'), 10) || 1023;

    const src = windowWidth > breakpoint ? this.getAttribute('data-desktop-vid') : this.getAttribute('data-mobile-vid');
    const posterSrc = windowWidth > breakpoint ? this.getAttribute('data-desktop-poster') : this.getAttribute('data-mobile-poster');

    const source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';

    if (this.video) {
      this.video.innerHTML = '';
      this.video.appendChild(source);
      // this.video.poster = posterSrc; // Uncomment to use
      this.video.load();
    }
  }

  debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

customElements.define('mobile-specific-video', MobileSpecificVideo);
